module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "siteIdentity"
  }, [_c('img', {
    staticClass: "backgroundImage",
    attrs: {
      "src": "http://e-zaigai.jp/static/images/obi.png"
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'top'
      }
    }
  }, [_c('h1', {
    staticClass: "siteTitle"
  }, [_vm._v(_vm._s(_vm.renderText(_vm.title.ja, _vm.title.en)))]), _c('h2', {
    staticClass: "siteSubTitle"
  }, [_vm._v(_vm._s(_vm.renderText(_vm.subTitle.ja, _vm.subTitle.en)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-430235d4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/identity.vue
// module id = 98
// module chunks = 1